window.tplogs = true;